import { __assign } from 'tslib';
import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { Calendar } from 'calendar-base';
import dateUtils from './calendar-utils/dateUtils.esm.js';
import { getWeekStartIndex, daysInWeek } from './calendar-utils/intl.esm.js';
import todayUtil from './calendar-utils/today.esm.js';

var sixWeeks = 6;
var sixWeeksInDays = sixWeeks * daysInWeek;
var useCalendarDays = function (_a) {
    var numMonthsToDisplay = _a.numMonthsToDisplay, year = _a.year, month = _a.month, siblingMonths = _a.showSiblingMonths, locale = _a.locale, maxDate = _a.maxDate, padWeeks = _a.padWeeks;
    var l10n = useLocalization();
    var today = React.useMemo(function () { return todayUtil.getToday(); }, []);
    var maxDateDay = React.useMemo(function () { return todayUtil.getMaxDate(maxDate); }, [maxDate]);
    var calendarData = React.useMemo(function () {
        var weekStart = getWeekStartIndex(l10n);
        return new Calendar({ siblingMonths: siblingMonths, weekStart: weekStart });
    }, [l10n, siblingMonths]);
    var daysByWeekAndMonth = React.useMemo(function () {
        var monthIndexes = Array.from(Array(numMonthsToDisplay).keys());
        return monthIndexes.map(function (monthIndex) {
            var _a = dateUtils.addMonthsToMonth(year, month, monthIndex), updatedMonth = _a.updatedMonth, updatedYear = _a.updatedYear;
            var monthDays = calendarData.getCalendar(updatedYear, updatedMonth).map(function (day) {
                return day
                    ? __assign(__assign({}, day), { dateString: dateUtils.getDayToString(day), localeDateString: new Date(Date.UTC(day.year, day.month, day.day)).toLocaleDateString(locale, {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            timeZone: 'UTC',
                            weekday: 'long'
                        }), isToday: todayUtil.isToday(day, today), isPast: todayUtil.isPast(day, today), isPastMaxDate: maxDateDay ? todayUtil.isAfter(day, maxDateDay) : false, position: {
                            monthIndex: monthIndex
                        } }) : false;
            });
            // This will make all months to have 6 weeks
            if (padWeeks) {
                var extraDaysToCompleteSixWeeks = sixWeeksInDays - monthDays.length;
                var extraDays = Array.from(Array(extraDaysToCompleteSixWeeks)).map(function () { return false; });
                monthDays = monthDays.concat(extraDays);
            }
            var weeksWithPosition = dateUtils.groupMonthDaysInWeeks(monthDays).map(function (week, weekIndex) {
                return week.map(function (day, dayIndex) {
                    return day
                        ? __assign(__assign({}, day), { position: __assign(__assign({}, day.position), { weekIndex: weekIndex, dayIndex: dayIndex }) }) : day;
                });
            });
            return {
                weeks: weeksWithPosition,
                month: updatedMonth,
                year: updatedYear
            };
        });
    }, [calendarData, locale, maxDateDay, month, numMonthsToDisplay, today, year, padWeeks]);
    return daysByWeekAndMonth;
};

export { sixWeeks, useCalendarDays };
